import { Link } from "react-router-dom";
import { NAV, COMPANY } from "@/data/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-border bg-background">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-6">
            <div className="font-mono text-xs tracking-[0.35em] text-primary uppercase mb-6">Techno Stamping &amp; Pressing</div>
            <p className="max-w-md text-muted-foreground">
              {COMPANY.tagline} — Your integrated partner for precision sheet metal manufacturing.
            </p>
          </div>
          <div className="lg:col-span-3">
            <div className="font-mono text-xs tracking-widest text-muted-foreground uppercase mb-5">Navigate</div>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.href}>
                  <a href={n.href} className="text-foreground/80 hover:text-primary transition-colors">{n.label}</a>
                </li>
              ))}
              <li><Link to="/admin/login" className="text-foreground/80 hover:text-primary transition-colors">Admin</Link></li>
            </ul>
          </div>
          <div className="lg:col-span-3">
            <div className="font-mono text-xs tracking-widest text-muted-foreground uppercase mb-5">Contact</div>
            <ul className="space-y-3 text-foreground/80">
              <li>{COMPANY.email}</li>
              <li>{COMPANY.phone}</li>
              <li className="text-sm text-muted-foreground">{COMPANY.address}</li>
            </ul>
          </div>
        </div>

        {/* Massive typographic wordmark */}
        <div className="border-t border-border pt-10">
          <h2 className="font-display font-semibold text-[15vw] leading-[0.8] tracking-tighter text-stroke select-none">
            TECHNO
          </h2>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row justify-between gap-4 text-sm text-muted-foreground">
          <span>© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</span>
          <span className="font-mono text-xs tracking-widest">ISO 9001:2015 CERTIFIED</span>
        </div>
      </div>
    </footer>
  );
}
